import { useUser } from "../hooks/useUser";

function Profile() {
  const { user } = useUser();

  console.log(user);

  return (
    <div>
      <div className="container mt-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-7">
            <div className="card p-3 py-4">
              <div className="text-center">
                <img
                  src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                  alt="profile"
                  width="100"
                  className="rounded-circle"
                />
              </div>

              <div className="text-center my-3">
                <span className="bg-secondary uppercase p-1 px-4 rounded text-white">{user.role}</span>
                <h5 className="mt-4 mb-0">User Name : {user.username}</h5>

                <div className="px-4 mt-4">
                  <ul className="list-group">
                    <li className="list-group-item mb-2">E-mail : {user.email}</li>
                  </ul>
                  <ul className="list-group">
                    <li className="list-group-item mb-2">Join date : {user.createdAt.split("T")[0]}</li>
                  </ul>
                  <ul className="list-group">
                    <li className="list-group-item mb-2">Role : {user.role}</li>
                  </ul>
                </div>

                <div className="buttons mt-4">
                  <button className="btn btn-primary px-4">Edit</button>
                  <button className="btn  btn-outline-danger px-4 ms-3">Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
